import React, {forwardRef} from "react";
import { 
    Typography,
    IconButton
} from '@material-ui/core';
import RoomLayout from '../../../components/RoomLayout/';
import { KeyboardBackspace } from 'mdi-material-ui';
import { NavLink } from 'react-router-dom';

const ForwardNavLink = forwardRef((props, ref) => (
    <NavLink {...props} innerRef={ref} />
))

const ManageLayout = (props) => {
    return (
        <>
            <div className="d-flex align-items-center mb-3">
                <IconButton size="small" className="me-1" component={ForwardNavLink} to={"/dashboard/listings"}>
                    <KeyboardBackspace/>
                </IconButton>
                <Typography variant="h6" className="mb-0">Property Layout</Typography>
            </div>
            <RoomLayout
                property_id={props.match.params.property_id}
            />
        </>
    )
}
export default ManageLayout; 